import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Container, Spinner } from "react-bootstrap";
import "./Timeline.css";
import photo from "../assets/fotos/medida.png";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";




const API_URL = "https://facach.coop.hn/api";




const FALLBACK = [
  { id: 1, year: 1966, title: "Organización de FACACH",               image_url: photo },
  { id: 2, year: 1970, title: "Consolidación de Servicios",           image_url: photo },
  { id: 3, year: 1980, title: "Fortalecimiento de Cooperativas",      image_url: photo },
  { id: 4, year: 1996, title: "Apertura del Mercado Bursátil",        image_url: photo },
  { id: 5, year: 2018, title: "Consolidación del Sector Cooperativo", image_url: photo },
  { id: 6, year: 2023, title: "ACTUALIDAD",                           image_url: photo },
];




const PrevArrow = ({ onClick }) => (
  <div className="tl-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);




const NextArrow = ({ onClick }) => (
  <div className="tl-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);




// Hook para saber si estamos en móvil
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);


  return isMobile;
};




const Timeline = () => {
  const [items, setItems]     = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(0);
  const isMobile              = useIsMobile(768);




  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res  = await fetch(`${API_URL}/timeline`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data.length > 0) setItems(json.data);
      } catch (err) {
        console.error("Error cargando timeline:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);




  // Settings diferentes según si estamos en móvil o no
  const settings = isMobile
    ? {
        // ── MÓVIL: un slide a la vez, sin centerMode
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        arrows: true,
        dots: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        afterChange: (idx) => setCurrent(idx),
      }
    : {
        // ── DESKTOP: coverflow con 3 slides y centerMode
        centerMode: true,
        centerPadding: "80px",
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        afterChange: (idx) => setCurrent(idx),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              centerPadding: "40px",
              centerMode: true,
            },
          },
        ],
      };




  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }




  return (
    <section className="timeline-section">
      <Container>
        <h2 className="timeline-title">NUESTRA HISTORIA</h2>
        <p className="timeline-subtitle">
          Más de 5 décadas impulsando el cooperativismo en Honduras
        </p>




        <div className={`timeline-track-wrap ${isMobile ? "is-mobile" : ""}`}>
          {/* key cambia entre mobile/desktop → Slick se reinicializa */}
          <Slider key={isMobile ? "mobile" : "desktop"} {...settings}>
            {items.map((item) => (
              <div key={item.id} className="tl-slide">
                <div className="tl-card">
                  {/* Imagen */}
                  <div className="tl-img-wrap">
                    <img
                      src={item.image_url || photo}
                      alt={item.image_alt || item.title}
                      className="tl-img"
                      onError={e => { e.target.src = photo; }}
                    />
                    <div className="tl-img-overlay" />
                    <div className="tl-year-badge">{item.year}</div>
                  </div>




                  {/* Cuerpo */}
                  <div className="tl-body">
                    <div className="tl-dot" />
                    <div className="tl-title">{item.title}</div>
                    {item.description_html && (
                      <div
                        className="tl-desc"
                        dangerouslySetInnerHTML={{ __html: item.description_html }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
};




export default Timeline;
